import React from "react";
import AboutComponent1 from "../../components/AboutComponents/AboutComponent1/AboutComponent1";
import { ImageUrl } from "../../config/helper";
import { Col, Row } from "antd";

const About = () => {
  return (
    <div>
      <AboutComponent1
        image={ImageUrl("about-banner.png")}
        heading="Terms and Conditions"
      />
      <Row justify="center" className="py-16 max-sm:py-8">
        <Col md={21} xs={22}>
          <div class="wpb_text_column wpb_content_element ">
            <div class="policy-box">
              <h2 class="wp-block-heading">Terms and Conditions</h2>
              <p>
                Welcome to Luxury Car Chauffeur Service (“Company,” “we,” “us,”
                or “our”). These Terms and Conditions (“Terms”) govern your
                access to and use of our website, services, and any affiliated
                offerings (collectively, the “Services”). By accessing or using
                our website, booking our services, or engaging with our
                platform, you agree to be bound by these Terms.
              </p>
              <p>
                Please read these Terms carefully before using our services. If
                you do not agree with any part of these Terms, you should not
                use our Services.
              </p>
              <ol>
                <li>
                  <strong> Acceptance of Terms</strong>
                </li>
              </ol>
              <p>
                By using our website or booking our services, you acknowledge
                that you have read, understood, and agree to be bound by these
                Terms, as well as any future modifications we may implement. We
                reserve the right to update or revise these Terms at our
                discretion, and it is your responsibility to review these Terms
                periodically.
              </p>
              <ol start="2">
                <li>
                  <strong> Services</strong>
                </li>
              </ol>
              <p>
                Luxury Car Chauffeur Service offers premium transportation
                services, including chauffeur-driven luxury vehicles for
                individual and group bookings. We provide the following types of
                services:
              </p>
              <ul>
                <li>Hourly chauffeur services</li>
                <li>Distance packages (based on mileage and time)</li>
                <li>Half-day and full-day service packages</li>
                <li>Special event and group transportation</li>
              </ul>
              <p>
                By booking our Services, you agree to abide by our policies
                regarding bookings, cancellations, usage, and payment as
                outlined below.
              </p>
              <ol start="3">
                <li>
                  <strong> Booking and Reservations</strong>
                </li>
              </ol>
              <p>
                3.1 <strong>Booking Confirmation</strong>
                <br />
                All bookings made through our website, app, or over the phone
                are subject to availability. Once a booking is made, you will
                receive a confirmation email detailing your reservation and
                payment terms.
              </p>
              <p>
                3.2 <strong>Changes to Booking</strong>
                <br />
                Changes to your booking, including changes to the vehicle type,
                service time, or pickup location, must be made at least 24 hours
                in advance. We will accommodate such requests as long as
                availability allows.
              </p>
              <p>
                3.3 <strong>Cancellations</strong>
                <br />
                Cancellations made 48 hours or more before the scheduled booking
                time will receive a full refund. Cancellations made less than 48
                hours before the scheduled service will incur a cancellation fee
                equal to 50% of the total booking fee. Same-day cancellations or
                no-shows will be charged the full booking amount.
              </p>
              <ol start="4">
                <li>
                  <strong> Packages and Pricing</strong>
                </li>
              </ol>
              <p>
                4.1 <strong>Distance Package</strong>
                <br />
                Our Distance Package is calculated based on the number of miles
                traveled and the time spent in transit. You will be charged a
                base rate per mile plus an hourly fee for the duration of the
                trip. Mileage is calculated from the point of pickup to the
                final drop-off location.
              </p>
              <p>
                4.2 <strong>Half-Day Package</strong>
                <br />
                Our Half-Day Package includes a minimum booking of four hours.
                Any additional time beyond four hours will incur an hourly
                charge. This package is suitable for short trips or special
                events requiring extended transportation.
              </p>
              <p>
                4.3 <strong>Full-Day Package</strong>
                <br />
                The Full-Day Package requires a minimum booking of eight hours
                and is designed for events or journeys requiring a chauffeur for
                an entire day. Any time exceeding eight hours will be billed at
                the standard hourly rate.
              </p>
              <p>
                4.4 <strong>Pricing and Fees</strong>
                <br />
                All prices are displayed in USD and are subject to change based
                on market conditions and seasonal demand. Prices may vary
                depending on the vehicle type, location, and time of booking.
                Additional fees, such as tolls, parking, and waiting charges,
                may apply.
              </p>
              <ol start="5">
                <li>
                  <strong> Payment</strong>
                </li>
              </ol>
              <p>
                5.1 <strong>Payment Methods</strong>
                <br />
                We accept all major credit cards, debit cards, and other payment
                methods as listed on our website. Full payment is required at
                the time of booking unless otherwise specified.
              </p>
              <p>
                5.2 <strong>Refunds</strong>
                <br />
                Refunds will only be issued in accordance with our cancellation
                policy. Any eligible refunds will be processed within 7-10
                business days to the original method of payment.
              </p>
              <ol start="6">
                <li>
                  <strong> User Responsibilities</strong>
                </li>
              </ol>
              <p>
                6.1 <strong>Accurate Information</strong>
                <br />
                You agree to provide accurate, up-to-date information when
                booking our Services. Failure to provide correct details may
                result in booking delays or cancellations.
              </p>
              <p>
                6.2 <strong>Conduct</strong>
                <br />
                Clients and their guests are expected to behave respectfully
                during the ride. The chauffeur has the right to terminate the
                service if any passenger behaves inappropriately, damages the
                vehicle, or engages in illegal activity. In such cases, no
                refunds will be provided, and additional fees may apply for
                damages or cleaning.
              </p>
              <p>
                6.3 <strong>Damage to Vehicle</strong>
                <br />
                You are responsible for any damage to the vehicle caused by you
                or your guests during the ride. We reserve the right to charge
                additional fees for repair, cleaning, or maintenance required as
                a result of misuse or damage caused during your ride.
              </p>
              <ol start="7">
                <li>
                  <strong> Chauffeur Responsibilities</strong>
                </li>
              </ol>
              <p>
                7.1 <strong>Punctuality</strong>
                <br />
                Our chauffeurs are committed to arriving on time for all
                scheduled bookings. However, unforeseen circumstances such as
                traffic or weather conditions may cause delays. In such cases,
                we will notify you promptly and work to minimize any disruption
                to your schedule.
              </p>
              <p>
                7.2 <strong>Safety</strong>
                <br />
                Our chauffeurs are highly trained professionals who prioritize
                the safety of all passengers. They will follow all traffic laws
                and regulations and reserve the right to terminate service if
                passenger behavior compromises safety.
              </p>
              <ol start="8">
                <li>
                  <strong> Limitation of Liability</strong>
                </li>
              </ol>
              <p>
                8.1 <strong>Service Availability</strong>
                <br />
                We strive to provide reliable and efficient service at all
                times. However, we do not guarantee that our Services will be
                free from interruptions, delays, or errors. We shall not be held
                responsible for any delays caused by external factors, including
                traffic, weather, or other unforeseen circumstances.
              </p>
              <p>
                8.2 <strong>Liability for Personal Items</strong>
                <br />
                We are not responsible for any personal items left in the
                vehicle during or after the ride. Please check your belongings
                before exiting the vehicle to ensure nothing is left behind.
              </p>
              <p>
                8.3 <strong>Limitation of Damages</strong>
                <br />
                To the fullest extent permitted by law, Luxury Car Chauffeur
                Service shall not be liable for any indirect, incidental,
                special, or consequential damages arising out of or in
                connection with the use of our Services. Our liability is
                limited to the total amount paid by you for the Services in
                question.
              </p>
              <ol start="9">
                <li>
                  <strong> Privacy Policy</strong>
                </li>
              </ol>
              <p>
                Your privacy is important to us. We collect and use personal
                information in accordance with our Privacy Policy, which
                outlines how we protect your data. By using our website or
                Services, you consent to our collection and use of personal
                information as described in the Privacy Policy.
              </p>
              <ol start="10">
                <li>
                  <strong> Intellectual Property</strong>
                </li>
              </ol>
              <p>
                All content on our website, including text, images, logos, and
                design, is the intellectual property of Luxury Car Chauffeur
                Service and may not be used, copied, or distributed without our
                express written consent.
              </p>
              <ol start="11">
                <li>
                  <strong> Governing Law</strong>
                </li>
              </ol>
              <p>
                These Terms shall be governed by and construed in accordance
                with the laws of the State of New York. Any disputes arising
                from these Terms or the use of our Services shall be resolved in
                the state or federal courts located in New York County.
              </p>
              <ol start="12">
                <li>
                  <strong> Termination of Service</strong>
                </li>
              </ol>
              <p>
                We reserve the right to terminate or refuse service to any
                individual at our discretion, especially in cases of
                non-compliance with these Terms or inappropriate conduct.
              </p>
              <ol start="13">
                <li>
                  <strong> Changes to Terms</strong>
                </li>
              </ol>
              <p>
                We reserve the right to modify these Terms at any time. Any
                changes will be posted on our website, and continued use of our
                Services after such changes constitutes acceptance of the new
                Terms.
              </p>
              <ol start="14">
                <li>
                  <strong> Contact Us</strong>
                </li>
              </ol>
              <p>
                If you have any questions or concerns regarding these Terms or
                our Services, please contact us at:
              </p>
              <p>
                <strong>Luxury Car Chauffeur Service</strong>
                <br />
                Email:{" "}
                <a href="mailto:info@luxuryccs.com">
                  Email: info@luxuryccs.com
                </a>
                <br />
                Phone:{" "}
                <a href="tel:8626664329">
                  (862) 666-4329
                  <br />
                </a>
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default About;
